module.exports = __webpack_public_path__ + "media/stylesheets/images/logo_mattrz_cx-b8fa31377a98225c707159ee993e2208.svg";